export default __webpack_public_path__ + "static/media/trash.7ec2a65f.svg";